// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={820.8}
      height={367.2}
      viewBox="0 0 820.8 367.2"
      {...props}
    >
      <path
        d="M56.07 312.49h85.874V54.948H56.069V312.49zM227.66 311.937h85.795V54.393H227.66v257.544zM379.157 54.546v257.063h85.812c184.243 11.623 236.2-246.783 21.75-257.063H379.157zm93.562 60.437c89.205-.416 92.864 138.718-11.312 132.032v-131.25c3.907-.498 7.686-.765 11.312-.782zM678.856 312.807h85.875V55.263h-85.875v257.544z"
        fill="#008147"
      />
      <path
        d="M141.865 228.356h85.874V142.56h-85.874v85.795z"
        fill="#d90021"
        stroke="#d90021"
        strokeWidth={0.909}
      />
    </svg>
  );
};

const HdiIcon = Icon;
export default HdiIcon;
